export default class SMSFilterCriteria {
    constructor({
      dateStart,
      dateEnd,
    } = {}) {
      this.dateStart = dateStart
      this.dateEnd = dateEnd
    }
  }